var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"recurringDiv"}},[_c('b-row',_vm._b({},'b-row',_vm.$attrs,false),[_c('b-col',{attrs:{"cols":"12"}},[_c('h5',[_vm._v(" "+_vm._s(_vm.recurringStatement)+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }